import { PlanSubmissionStatus } from '@ebalance/proto/bfftypes/v1/plan_submission_pb'

/**
 * 計画詳細のヘッダーの「提出」 を押せない状態と、 画面上に文で出す押せない理由
 * (spec `plan-submit/plan-common.md` AC-PLC-062、 conventions.md「操作できない時のボタンの扱い」)。
 *
 * 作成中・承認待ち・提出済・処理中は待てば提出できる状態に戻るので、 非活性 + 理由の文を常に出す
 * (conventions.md の 2)。 受領済の版は提出できる状態に戻らないので、 理由はツールチップで示す
 * (conventions.md の 3。 [[showsSubmitBlockReasonText]])。 ここに無い状態 (作成失敗・編集中 等) は理由を出さない。
 * 文言は画面横断の `page:planSubmission.submitBlockReason.*`。
 */
const SUBMIT_BLOCK_REASON_KEYS: Partial<Record<PlanSubmissionStatus, string>> =
  {
    [PlanSubmissionStatus.GENERATING]:
      'page:planSubmission.submitBlockReason.generating',
    [PlanSubmissionStatus.APPROVAL_PENDING]:
      'page:planSubmission.submitBlockReason.approvalPending',
    [PlanSubmissionStatus.SUBMITTED]:
      'page:planSubmission.submitBlockReason.submitted',
    [PlanSubmissionStatus.ACCEPTED]:
      'page:planSubmission.submitBlockReason.accepted',
    [PlanSubmissionStatus.SUBMITTING]:
      'page:planSubmission.submitBlockReason.submitting',
  }

export function submitBlockReasonKey(
  status: PlanSubmissionStatus,
): string | undefined {
  return SUBMIT_BLOCK_REASON_KEYS[status]
}

/**
 * 押せない理由を、 ボタンの直下に文として出すか (ツールチップには常に出す)。
 *
 * 受領済 (需要調達計画・発電販売計画) は文を出さず、 ツールチップで示す (AC-PLC-062、
 * #10407 の PdM 決定 / spec #10425)。 この版は提出できる状態に戻らず、 値を変える時は作り直した
 * 新しい版を提出する (conventions.md「操作できない時のボタンの扱い」 の 3 は理由をツールチップで示す)。
 */
export function showsSubmitBlockReasonText(
  status: PlanSubmissionStatus,
): boolean {
  return status !== PlanSubmissionStatus.ACCEPTED
}
